export const COLORS = {
  bgLight: 0xFAF8F5,
  feltMat: 0xF3EFEA,
  feltBorder: 0xE5DFD5,
  feltInnerGlow: 0xFFFFFF,
  accentGold: 0xF59E0B,
  accentBlue: 0x0284C7,
  accentGreen: 0x16A34A,
  accentRed: 0xDC2626,
  accentPurple: 0x9333EA,
  accentPink: 0xEC4899,
  cardBorder: 0xE2DCD2,
  textDark: 0x27272A,
  textMuted: 0x71717A,
  turnHighlight: 0xFBBF24,
  corvenRed: 0xEF4444,
};

export const CARD_WIDTH = 135;
export const CARD_HEIGHT = 189; // Exact 2.5 : 3.5 poker ratio (5 : 7)
export const CARD_RADIUS = 10;
